import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { AccessHistory } from '../models';

export enum AccessHistoryActionTypes {
  ToggleAccessHistoryPageLoading = '[AccessHistory] Toggle AccessHistory Page Loading',
  RequestAccessHistoryPage = '[AccessHistory] Request AccessHistory Page',
  LoadAccessHistoryPage = '[AccessHistory] Load AccessHistory Page',
  CancelAccessHistoryPage = '[AccessHistory] Cancel AccessHistory Page',
  ThrowAccessHistoryError = '[AccessHistory] Throw AccessHistory Error',
  ClearAccessHistoryError = '[AccessHistory] Clear AccessHistory Error',
}

export class ToggleAccessHistoryPageLoading implements Action {
  readonly type = AccessHistoryActionTypes.ToggleAccessHistoryPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class RequestAccessHistoryPage implements Action {
  readonly type = AccessHistoryActionTypes.RequestAccessHistoryPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadAccessHistoryPage implements Action {
  readonly type = AccessHistoryActionTypes.LoadAccessHistoryPage;

  constructor(
    public payload: {
      accessHistories: AccessHistory[];
      totalCount: number;
      query: QueryParamsModel;
    },
  ) {}
}

export class CancelAccessHistoryPage implements Action {
  readonly type = AccessHistoryActionTypes.CancelAccessHistoryPage;
}

export class ThrowAccessHistoryError implements Action {
  readonly type = AccessHistoryActionTypes.ThrowAccessHistoryError;

  constructor(public payload: { error: any }) {}
}

export class ClearAccessHistoryError implements Action {
  readonly type = AccessHistoryActionTypes.ClearAccessHistoryError;
}

export type AccessHistoryActions =
  | ToggleAccessHistoryPageLoading
  | RequestAccessHistoryPage
  | LoadAccessHistoryPage
  | CancelAccessHistoryPage
  | ThrowAccessHistoryError
  | ClearAccessHistoryError;
